export const getMapOptions = (
  isSmall: boolean,
  isWebView: boolean,
  isMarkerDraggable = false
) => {
  const winAvailable = typeof window !== 'undefined';

  const streetViewPosition = winAvailable && isSmall ? 'RIGHT_TOP' : 'LEFT_TOP';
  const mapTypeControlPosition =
    winAvailable && isSmall ? 'TOP_RIGHT' : 'TOP_LEFT';
  const cameraControlPosition =
    winAvailable && isSmall ? 'INLINE_END_BLOCK_CENTER' : 'LEFT_BOTTOM';

  const webViewStreetViewPosition = 'LEFT_BOTTOM';
  const webViewMapTypeControlPosition = 'RIGHT_BOTTOM';

  const mapOptions = {
    clickableIcons: !isMarkerDraggable,
    fullscreenControl: false,
    zoomControl: false,
    mapTypeControl: false,
    streetViewControl: false,
    streetViewControlOptions: {
      position:
        window.google?.maps?.ControlPosition?.[
          isWebView ? webViewStreetViewPosition : streetViewPosition
        ]
    },
    mapTypeControlOptions: {
      style: winAvailable
        ? window.google?.maps?.MapTypeControlStyle?.HORIZONTAL_BAR
        : undefined,
      position:
        window.google?.maps?.ControlPosition?.[
          isWebView ? webViewMapTypeControlPosition : mapTypeControlPosition
        ]
    },
    cameraControlOptions: {
      position: window.google?.maps?.ControlPosition?.[cameraControlPosition]
    },
    gestureHandling: isMarkerDraggable ? 'greedy' : 'auto'
  };

  const mapHeight = '100%';

  const mapStyle = {
    width: '100%',
    height: mapHeight
  };

  return {
    mapStyle,
    mapOptions,
    mapHeight
  };
};
